module.exports = __webpack_public_path__ + "img/icon_02.c8ed78c4.png";